import Axios from "axios";

export const axios = Axios.create();
// Request interceptor for API calls
axios.interceptors.request.use(
    (config) => {
        try {            // Check if this is the image generation endpoint
            const isImageGenerationEndpoint = config.url && 
                (config.url.includes('/auth/customize/generateGptImage') || 
                 config.url.includes('/images/') ||
                 config.url.includes('/customers/images'));

            // Check if the request is to a shop endpoint
            const isShopEndpoint = config.url && 
                (config.url.includes('/shop/'));
            
            // Check if the request is to a customer endpoint - expanded to catch more patterns
            const isCustomerEndpoint = config.url &&
                (config.url.includes('/customers/') ||
                 config.url.includes('/customers') ||
                 config.url.includes('/billing/customer/') ||
                 config.url.includes('/customer-billing/') ||
                 config.url.includes('/customer/') ||
                 config.url.includes('/customer/account') ||
                 config.url.includes('/customer-auth/') ||
                 (config.url.includes('/metrics/orders/') && 
                  (config.url.includes('/download-info') || 
                   config.url.includes('/download'))));

            // Special handling for image generation endpoints
            if (isImageGenerationEndpoint) {
                // Try to get both tokens
                const creatorToken = localStorage.getItem("SparkleAuthToken");
                const customerToken = localStorage.getItem("SparkleCustomerToken");
                
                // If we have both tokens, use them appropriately
                if (creatorToken && customerToken) {
                    // For image endpoints, send both tokens
                    config.headers["x-access-token"] = creatorToken;      // Primary token (creator)
                    config.headers["x-customer-token"] = customerToken;   // Customer token
                }
                // If we only have creator token
                else if (creatorToken) {
                    config.headers["x-access-token"] = creatorToken;
                }
                // If we only have customer token
                else if (customerToken) {
                    config.headers["x-access-token"] = customerToken;
                    config.headers["is-customer"] = "true";  // Flag to help backend identify customer token
                }            } 
            // Standard handling for all other endpoints
            else {                // Use creator token for shop endpoints, customer token for customer endpoints
                const tokenKey = isCustomerEndpoint ? "SparkleCustomerToken" : 
                                 isShopEndpoint ? "SparkleAuthToken" : "SparkleAuthToken";
                const token = localStorage.getItem(tokenKey);

                if (token) {
                    config.headers["x-access-token"] = token;
                    // Add customer flag if using customer token
                    if (isCustomerEndpoint) {
                        config.headers["is-customer"] = "true";
                    }
                    
                    // Debug logging
                    console.log(`Setting token for URL: ${config.url}`);
                    console.log(`Token key used: ${tokenKey}`);
                    console.log(`Token present: ${token ? 'Yes' : 'No'}`);
                } else {
                    // Debug logging for missing token
                    console.log(`No token found for URL: ${config.url}`);
                    console.log(`Token key tried: ${tokenKey}`);
                }
            }

        } catch (e) {
            // localStorage is not available
            console.error("Error in axios interceptor:", e);
        }

        return config;
    },
    (error) => Promise.reject(error),
);
